export default defineNuxtPlugin((nuxtApp) => {
  const authStore = useAuthStore()
  const i18n = nuxtApp.$i18n

  watch(
    () => [authStore.isLoggedIn, authStore.preferredLanguage] as const,
    async ([isLoggedIn, preferredLanguage]) => {
      if (!isLoggedIn) return

      const language = preferredLanguage ?? detectBrowserLanguage()
      if (i18n.locale.value !== language) await i18n.setLocale(language)
    },
    { immediate: true },
  )
})
